import L, { LatLng, PolylineOptions } from 'leaflet';
import { FeatureGroup, Marker, useMap } from 'react-leaflet';
import { divIconNumbers } from '../MapComponents/mapIcons';
import React, { useEffect, useMemo, useRef } from 'react';
import { Trail } from '../../models/Trail';
import { getTrailPathLatLngs, toLatLng } from './mapPointUtils';

const LINE_OPTIONS: PolylineOptions = {
	color: '#666',
	opacity: 1.0,
	fill: false,
};

const ACTIVE_LINE_OPTIONS: PolylineOptions = {
	color: '#f00',
	opacity: 1.0,
	fill: false,
};

// @ts-ignore
function PolylineDecorator({ polyline, isActive }) {
	const polyRef = useRef<L.Polyline[]>([]);
	const map = useMap();
	useEffect(() => {
		if (!map) {
			return;
		}

		polyRef.current.forEach((line) => {
			map.removeLayer(line);
		});
		polyRef.current = [];

		const lineStyle = isActive ? ACTIVE_LINE_OPTIONS : LINE_OPTIONS;
		const line = L.polyline(polyline, lineStyle);
		polyRef.current.push(line);
		line.addTo(map);

		return () => {
			polyRef.current.forEach((activeLine) => {
				map.removeLayer(activeLine);
			});
			polyRef.current = [];
		};
	}, [isActive, map, polyline]);

	return null;
}

type ShowTrailProps = {
	trail: Trail;
};

const ShowSingleTrail: React.FC<ShowTrailProps> = ({ trail }) => {
	const svgPoints = useMemo(() => getTrailPathLatLngs(trail), [trail]);

	const markerPoints = useMemo(() => {
		const markers: LatLng[] = [];
		const lastIndex = trail.waypoints.length - 1;

		trail.waypoints.forEach((the_point, index) => {
			const latLng = toLatLng(the_point);
			if (!latLng) {
				return;
			}
			if (the_point.is_poi || index === 0 || index === lastIndex) {
				markers.push(latLng);
			}
		});

		return markers;
	}, [trail]);

	return (
		<>
			<FeatureGroup key={`trail-line-${trail.id}`}>
				<PolylineDecorator polyline={svgPoints} isActive={true} />
			</FeatureGroup>
			{markerPoints.length > 0 && (
				<FeatureGroup key={`trail-${trail.id}-points`}>
					{markerPoints.map((p, idcc) => (
						<Marker
							key={`trail-${trail.id}-point.${idcc}`}
							position={p}
							icon={
								divIconNumbers[idcc] ??
								divIconNumbers[divIconNumbers.length - 1]
							}></Marker>
					))}
				</FeatureGroup>
			)}
		</>
	);
};

export default ShowSingleTrail;
